import { clinicActionResendInvitation } from 'lib/api/firebase/apis/apis';
import {
  ActionState,
  ActionTagSettings
} from '../../../../../../components/action-tag/action-tag-component';
import { TableRow } from '../user-table-types';

export const BASE_ACTIONS: ActionTagSettings<TableRow>[] = [
  {
    name: 'Resend invite',
    shouldShow: p => p.invitePending,
    initialState: () => ActionState.NEUTRAL,
    onClick: p => {
      if (!p.raw.id) {
        throw new Error('ID is undefined. Please try reloading the page');
      }
      return clinicActionResendInvitation({
        invitationId: p.raw.id,
        resendType: 'email'
      });
    }
  }
];
